import
  React
from 'react';

import {
  VContainerH,
  VFillContainerVH
} from '@vodacom/web-common';

import {
  CustomColors
} from '../../../../constants';

import {
  SummaryCard
} from '.';

import {
  Line,
  TextRow
} from 'components';

import {
  formatDate,
  printCurrency
} from 'helpers';

export const PaymentsTab = (props) => {

  const getPayments = () => {
    return props.repaymentHistory?.map(payment =>
      {
        return {
          leftText: formatDate(payment.transactionTimestamp),
          rightText: printCurrency(props.voucherCost)
        };
      }
    );
  };

  const Content = () => {

    return (

      <VFillContainerVH>

        <SummaryCard
          margin={'12px 0'}
          primaryTitle={'Payment summary'}
          primaryTextRows={[
            { leftText: 'Opening balance:', rightText: printCurrency(props.voucherCost) },
            { leftText: 'Opening date:', rightText: props.purchaseDate },
            { leftText: 'Payment due date:', rightText: props.paymentDue },
            { leftText: 'Remaining balance:', rightText: printCurrency(props.outstandingAmount) }
          ]}
          secondaryTitle={'Payments'}
          secondaryTextRows={getPayments()}/>

        <VContainerH
          boxSizing={'border-box'}
          width={'100%'}
          padding={'20px'}
          backgroundColor={CustomColors.White}>

          <TextRow
            leftText={'Outstanding amount'}
            rightText={'R 35.00'}/>

          <Line/>
        </VContainerH>

      </VFillContainerVH>
    );
  };

  return <Content/>;
};
